import React from 'react';

function StartupCard({ startup, onInvest, canInvest }) {
  const totalInvested = parseFloat(startup.total_invested || 0);
  const investorCount = parseInt(startup.investor_count || 0);

  return (
    <div className="card hover:scale-105 transition-transform duration-300">
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <h3 className="text-2xl font-bold text-gray-900 mb-2">{startup.name}</h3>
          <p className="text-gray-600 text-sm mb-4">{startup.description}</p>
        </div>
        <div className="ml-4 flex-shrink-0">
          <div className="w-16 h-16 bg-gradient-to-br from-primary-500 to-secondary-500 rounded-xl flex items-center justify-center text-white text-2xl font-bold">
            {startup.name.charAt(0)}
          </div>
        </div>
      </div>

      <div className="border-t border-gray-200 pt-4 mt-4">
        <button
          onClick={onInvest}
          disabled={!canInvest}
          className={`w-full py-3 rounded-xl font-semibold transition-all duration-200 ${
            canInvest
              ? 'bg-gradient-to-r from-primary-600 to-primary-700 text-white hover:from-primary-700 hover:to-primary-800 shadow-md hover:shadow-lg transform hover:-translate-y-0.5'
              : 'bg-gray-300 text-gray-500 cursor-not-allowed'
          }`}
        >
          {canInvest ? 'Invest' : 'Budget Exhausted'}
        </button>
      </div>
    </div>
  );
}

export default StartupCard;
